import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { fetchRezeptInvoiceInit } from '@/services/main/rezept';
import useAppToast from '@/hooks/useAppToast';
import { getApiErrorMessage, DEFAULT_FETCH_ERROR_MESSAGE } from '@/utils/apiError';
import { useClinicContext } from './useClinicContext';
import { useTheme } from '@shared/providers/theme/ThemeContext';

/**
 * Init hook for the 領収書・請求書 screen — returns master data (massagers) + default dates.
 * Called on component mount.
 */
export const useRezeptInvoiceInit = (options?: { enabled?: boolean }) => {
  const { tenant, clinicNumber } = useClinicContext();
  const { serviceType } = useTheme();
  const toast = useAppToast();

  const { data, isLoading, isFetching, isError, error, refetch } = useQuery({
    queryKey: ['rezept-invoice', 'init', tenant, clinicNumber, serviceType],
    queryFn: () => fetchRezeptInvoiceInit(tenant, clinicNumber),
    enabled: (options?.enabled ?? true) && !!tenant && !!clinicNumber,
    staleTime: 5 * 60_000,
  });

  useEffect(() => {
    if (isError && error) {
      toast.error(getApiErrorMessage(error, DEFAULT_FETCH_ERROR_MESSAGE));
    }
  }, [isError, error, toast]);

  return { data, isLoading, isFetching, isError, error, refetch };
};

export default useRezeptInvoiceInit;
